<template>
  <div class="mx-3">
    <v-card>
      <v-card-title>
        <h2>My Cases</h2>
      </v-card-title>
      <v-card-text>
        <case-list />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import CaseList from './Case/CaseList.vue'

export default {
  components: {
    CaseList
  },
  created () {
    this.$store.dispatch('changeShowToolbar', true)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue